import { atom } from "recoil";

export const widgetsState = atom({
  key: "widgetsState",
  default: { dashboard: [], workspace: {} },
});
